import gsap from 'gsap';

// Split text into individual characters manually
function splitText(element) {
  const text = element.textContent;
  const chars = text.split('');

  // Clear the element
  element.textContent = '';

  // Create a span for each character
  const charElements = chars.map(char => {
    const span = document.createElement('span');
    span.textContent = char === ' ' ? '\u00A0' : char; // Use non-breaking space for spaces
    span.style.display = 'inline-block';
    element.appendChild(span);
    return span;
  });

  return charElements;
}

// Initialize hero title and subnav animations
export function initHeroAnimation() {
  const heroTitles = document.querySelectorAll('.hero-block__title');

  heroTitles.forEach(title => {
    // Skip if already split
    if (title.dataset.split === 'true') return;
    title.dataset.split = 'true';

    // Split text into individual characters
    const chars = splitText(title);

    // Set initial state
    gsap.set(chars, {
      opacity: 0,
      y: 20
    });

    // Animate each character
    gsap.to(chars, {
      opacity: 1,
      y: 0,
      duration: 0.8,
      ease: 'power3.out',
      stagger: 0.03,
      delay: 0.5
    });
  });

  // Animate subnav items (check for hero block first)
  const hasHeroBlock = document.querySelector('.hero-block');

  if (hasHeroBlock) {
    // Look for subnav items anywhere on the page when there's a hero block
    const subnavItems = document.querySelectorAll('.subnav li');

    console.log('Hero block found, subnav items:', subnavItems.length);

    if (subnavItems.length > 0) {
      // Skip if already animated
      const firstItem = subnavItems[0];
      if (firstItem.dataset.animated === 'true') {
        console.log('Subnav already animated, skipping');
        return;
      }

      // Mark as animated
      subnavItems.forEach(item => {
        item.dataset.animated = 'true';
      });

      // Set initial state for subnav items
      gsap.set(subnavItems, {
        opacity: 0,
        y: 20
      });

      // Calculate total duration of title animation
      const titleDelay = 0.5;
      const titleElement = document.querySelector('.hero-block__title');
      const titleLength = titleElement ? titleElement.textContent.length : 0;
      const titleStaggerDuration = 0.03 * titleLength;
      const titleTotalDuration = titleDelay + titleStaggerDuration + 0.8;

      console.log('Animating subnav items:', subnavItems.length, 'delay:', titleTotalDuration + 0.3);

      // Animate subnav items with stagger, delayed to start after title
      gsap.to(subnavItems, {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: 'power3.out',
        stagger: 0.1,
        delay: titleTotalDuration - 0.5 // Start 0.3s after title finishes
      });
    }
  }
}
